import { render, staticRenderFns } from "./SideTagsStakeholder.vue?vue&type=template&id=54baa672&scoped=true&"
import script from "./SideTagsStakeholder.vue?vue&type=script&lang=js&"
export * from "./SideTagsStakeholder.vue?vue&type=script&lang=js&"
import style0 from "./SideTagsStakeholder.vue?vue&type=style&index=0&id=54baa672&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54baa672",
  null
  
)

export default component.exports